import { render, staticRenderFns } from "./addAfterService.vue?vue&type=template&id=01a37f6e&scoped=true"
import script from "./addAfterService.vue?vue&type=script&lang=js"
export * from "./addAfterService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a37f6e",
  null
  
)

export default component.exports